export default __webpack_public_path__ + "b69837871e2ef32b6802932f909dd089.png";